import React from 'react';
import propTypes from 'prop-types';
;
import { Control, Field, Label } from 'src/ui/mui-ui-kit'

export function UiToggle({ id, children, ...props }) {
  return (
    <Field className="ui-toggle">
      <Control>
        <input type="checkbox" id={id} {...props} />
        <Label htmlFor={id}>{children}</Label>
      </Control>
    </Field>
  );
}

UiToggle.defaultProps = {
  id: '',
};

UiToggle.propTypes = {
  id: propTypes.string,
  children: propTypes.node.isRequired,
};
